import { CreateUserButton } from "../../components/user/CreateUserButton";
import { AllUsersTable } from "../../components/user/UserTable";
import { useActiveUserRoles } from "../../util/useActiveUserRoles";

export function Users() {
  const { isSolutionOperator } = useActiveUserRoles();
  
  return (
    <AllUsersTable
      footer={isSolutionOperator ? <CreateUserButton /> : undefined}
      hideFooter={false}
    />
  );
}
